export default __webpack_public_path__ + "47cb4ddb3d01e99466d951700087110b.png";